/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Section } from './Section.js';
import {
    SectionFromJSON,
    SectionFromJSONTyped,
    SectionToJSON,
} from './Section.js';

/**
 * 
 * @export
 * @interface SectionListResponse
 */
export interface SectionListResponse {
    /**
     * 
     * @type {Array<Section>}
     * @memberof SectionListResponse
     */
    data?: Array<Section>;
    /**
     * 
     * @type {number}
     * @memberof SectionListResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof SectionListResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SectionListResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof SectionListResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the SectionListResponse interface.
 */
export function instanceOfSectionListResponse(value: object): boolean {
    return true;
}

export function SectionListResponseFromJSON(json: any): SectionListResponse {
    return SectionListResponseFromJSONTyped(json, false);
}

export function SectionListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SectionListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(SectionFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function SectionListResponseToJSON(value?: SectionListResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(SectionToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

